<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between align--center mb-3">
          <h1 class="ma-0">Исключения слотов</h1>
          <va-button color="info" @click="openCreateModal">
            Добавить исключение
          </va-button>
        </div>
        <va-data-table
          :fields="fields"
          :data="list"
          class="va-table va-table--hoverable"
        >
          <template slot="date" slot-scope="props">
            {{ props.rowData.date }}
          </template>
          <template slot="delivery_type" slot-scope="props">
            {{ getSlotTypeTitle(props.rowData.delivery_slot_id) }}
          </template>
          <template slot="slot" slot-scope="props">
            {{ getSlotTimeLabel(props.rowData.delivery_slot_id) }}
          </template>
          <template slot="is_available" slot-scope="props">
            <va-badge
              :text="props.rowData.is_available ? 'Да' : 'Нет'"
              :color="props.rowData.is_available ? 'success' : 'gray'"
            />
          </template>
          <template slot="actions" slot-scope="props">
            <va-button
              flat
              small
              color="gray"
              icon="fa fa-pencil"
              @click="edit(props.rowData)"
            />
            <va-button
              flat
              small
              color="gray"
              icon="fa fa-trash"
              @click="remove(props.rowData.id)"
            />
          </template>
        </va-data-table>
      </va-card>
    </va-inner-loading>

    <va-modal v-model="showModal" hide-default-actions size="medium">
      <template #header>
        <span>{{ editId ? "Редактировать" : "Новое исключение" }}</span>
      </template>
      <DeliverySlotExceptionForm
        :initial="editItem"
        :slots="slotOptions"
        @submit="onSubmit"
        @cancel="closeModal"
      />
    </va-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import DeliverySlotExceptionForm from "../../components/delivery-management/DeliverySlotExceptionForm.vue";

export default {
  name: "DeliverySlotExceptions",
  components: { DeliverySlotExceptionForm },
  data() {
    return {
      showModal: false,
      editId: null,
      editItem: null,
    };
  },
  computed: {
    ...mapState("deliverySlotExceptions", ["list"]),
    ...mapGetters({ loader: "isLoading" }),
    slotsList() {
      return this.$store.state.deliverySlots.list || [];
    },
    typesList() {
      return this.$store.state.deliveryTypes.list || [];
    },
    slotOptions() {
      const slots = this.slotsList || [];
      const types = this.typesList || [];
      return slots
        .filter((s) => s.id != null)
        .map((s) => {
          const type = types.find(
            (t) => Number(t.id) === Number(s.delivery_type_id)
          );
          const from = String(s.time_from || "").substring(0, 5);
          const to = String(s.time_to || "").substring(0, 5);
          return {
            value: Number(s.id),
            text: `${type ? type.title : "—"} (${from}–${to})`,
          };
        });
    },
    fields() {
      return [
        { name: "__slot:date", title: "Дата" },
        { name: "__slot:delivery_type", title: "Тип доставки" },
        { name: "__slot:slot", title: "Слот" },
        { name: "__slot:is_available", title: "Доступен" },
        { name: "__slot:actions", title: "", width: "100px" },
      ];
    },
  },
  async created() {
    await Promise.all([
      this.$store.dispatch("deliveryTypes/fetchList"),
      this.$store.dispatch("deliverySlots/fetchList"),
      this.fetchList(),
    ]);
  },
  methods: {
    ...mapActions("deliverySlotExceptions", [
      "fetchList",
      "create",
      "update",
      "delete",
    ]),
    getSlotTypeTitle(slotId) {
      const slot = this.slotsList.find((s) => s.id === slotId);
      if (!slot) return "—";
      const t = this.typesList.find(
        (x) => Number(x.id) === Number(slot.delivery_type_id)
      );
      return t ? t.title : "—";
    },
    getSlotTimeLabel(slotId) {
      const slot = this.slotsList.find((s) => s.id === slotId);
      if (!slot) return "—";
      const from = String(slot.time_from || "").substring(0, 5);
      const to = String(slot.time_to || "").substring(0, 5);
      return `${from}–${to}`;
    },
    openCreateModal() {
      this.editId = null;
      this.editItem = null;
      this.showModal = true;
    },
    edit(row) {
      this.editId = row.id;
      this.editItem = { ...row };
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.editId = null;
      this.editItem = null;
    },
    async onSubmit(form) {
      try {
        if (this.editId) {
          await this.update({ id: this.editId, ...form });
          this.$notify?.({ type: "success", title: "Сохранено" });
        } else {
          await this.create(form);
          this.$notify?.({ type: "success", title: "Создано" });
        }
        this.closeModal();
      } catch (e) {
        this.$notify?.({
          type: "error",
          title: "Ошибка",
          text: e.response?.data?.message || "Ошибка",
        });
      }
    },
    async remove(id) {
      if (!confirm("Удалить исключение?")) return;
      try {
        await this.delete(id);
        this.$notify?.({ type: "success", title: "Удалено" });
      } catch (e) {
        this.$notify?.({
          type: "error",
          title: "Ошибка",
          text: e.response?.data?.message || "Ошибка",
        });
      }
    },
  },
};
</script>
